// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import DatePresenter from "components/other/DatePresenter";
import UserMediaSkeletor from "components/user/UserMediaSkeletor";
import DynamicLockIcon from "components/icons/DynamicLockIcon";

// #####################################################

const UserWrapper = ({
	userInfo: { data },
	contentInfo,
	showComments,
	closeModal,
}) => {
	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);
	return data ? (
		<UserMediaSkeletor
			alignCenter
			noMarginBottom
			user={{
				...data,
				status_vip: data.statusVip,
			}}
			color={isDarkMode ? "black" : "white"}
			size={"xxsmall"}
			loginSize={"xsmall"}
			closeModal={closeModal}
			maxWidthWithEllipsis={"70vw"}
			headerLeft={
				showComments ? (
					<Block flex>
						<Text size="0.8rem" color="whiteAlways">
							<DatePresenter date={contentInfo.data.dateAdd} />
							{contentInfo.data.private ? (
								<DynamicLockIcon customMargin="0 0 0 0.5rem" />
							) : null}
						</Text>
					</Block>
				) : (
					<Block flex>
						<Text size="0.8rem" color="grey">
							&nbsp;
						</Text>
					</Block>
				)
			}
		/>
	) : null;
};

// #####################################################

export default UserWrapper;
